<template>
<div>
    <el-tabs :class="getPrimaryColor" v-model="activeTab" @tab-click="filterTab">
        <el-tab-pane label="Aprovados" name="1" />
        <el-tab-pane label="Reprovados" name="2" />
        <el-tab-pane label="Todos" name="0" />
    </el-tabs>
</div>
</template>

<script>
export default {
    data() {
        return {
            activeTab: this.$store.state.tabs.providerTab,
        }
    },
    methods: {
        filterTab() {
            this.$store.commit('tabs/setProviderTab', this.activeTab)
            this.$emit('tabSelect', this.activeTab)
        }
    },
}
</script>

<style>
.el-tabs .el-tabs__header .el-tabs__nav-wrap .el-tabs__nav-scroll .el-tabs__nav .el-tabs__item {
    font-weight: 500;
    color: #727D94
}
</style>
